import styled from 'styled-components'
import { ReactComponent as SpinnerSvg } from './assets/spinner.svg'

export const Spinner = styled(SpinnerSvg)`
  animation: rotate 2s linear infinite;
  z-index: 10;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -25px 0 0 -25px;
  width: 50px;
  height: 50px;

  .path {
    stroke: ${({ theme }) => theme.colors.lightPurple};
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`
